import useSWR from 'hooks/useSWR';
import { CompanyActivity } from 'types/company';
import { useSWRResource } from 'util/resource/useSWRResource';
import { companiesAPIUrls } from './companiesApi';

export const useCompanyPulse = (companySlug: string) => {
  const swrResult = useSWR<{ values: CompanyActivity[] }>(companiesAPIUrls.pulse.list(companySlug));
  return useSWRResource(swrResult);
};
